module.exports = __webpack_public_path__ + "img/chat-gpt.8e5bf582.svg";